/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react"
import { IPrimitiveProps } from "../../section/Primitive"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ICard, SILHOUETTE } from "src/modules/pe-landing-module/data/interfaces"
import Circle from "./Circle"
import Dot from "./Dot"
import FigureLine from "./FigureLine"

/* Protopia Ecosystem component */
export const COLORS =  [
    "#93194b",
    "#437942",
    "#909319",
    "#037772",
    "#b55500",
    "#9b724e",
    "#9b00b5",
]
export interface IInFoGraphicFigureProps extends IPrimitiveProps {
   
}
const InFoGraphicFigure = (props: IInFoGraphicFigureProps): JSX.Element => {
    const length = props.primitive?.cards.length || 2
    const id = props.primitive?.id.toString() || "0"
    const height = props.primitive?.size || 300
    const silhouette_gap = props.primitive?.silhouette_gap || 0
    const dotSize = props.primitive?.dotSize || 10
    const silhouette  = props.primitive?.silhouette || SILHOUETTE.CHESS_HORSE
    useEffect(() => {
        addCSSClass(
            `figure-${ props.primitive!.id }`,
            `
            .figure-${ props.primitive!.id } {
                height: 0;
                & > div {
                    width: ${height}px;
                    height: ${height / length}px;
                    position: absolute;
                    overflow: hidden;
                }
                .info-graphics-figure {
                    mask-image: url(/assets/img/landing/silhouette/${ silhouette }.svg);
                    width: ${height}px;
                    height: ${height}px;
                    mask-size: ${height}px ${height}px;
                    mask-position-x: center;
                    mask-position-y: center;
                    mask-repeat: no-repeat;
                } 
            }`
        )
        return () => removeCSSClass( `figure-${ props.primitive!.id }` )
    }, [ props.primitive ])
    return <div className="position-relative" style={{height: height, width: height}} >
        {
            props.primitive?.cards.map((card: ICard, i: number) => ( 
                <FigureLine key={card.id} id={id} i={i} length={length} height={height} gap={silhouette_gap}/> 
            ))            
        }
        {/* <Circle id={id} radius={height / 2 + 20 } /> */}
        {
            props.primitive?.cards.map((card: ICard, i: number) => (
                <Dot 
                    key={card.id}
                    id={id} 
                    i={i} 
                    length={ length } 
                    height={ height / length * ( i + .5 ) } 
                    radius={ dotSize }
                    left={ height / 2 - dotSize / 2 }
                /> 
            ))            
        }
    </div>
}
export default InFoGraphicFigure
